module.exports = __webpack_public_path__ + "media/couriers/ups_logo-30958a45.png";